

















import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { IUser } from 'admiral-core';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import UserSelect from '@/components/common/selects/UserSelect.vue';

dayjs.extend(Weekday);
dayjs.locale('de');

@Component({
  name: 'user-filter',
  components: {
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    UserSelect,
  },
})
export default class UserFilterComponent extends mixins(FilterMixin) {
  @Prop({ type: Array })
  selected!: IUser[];

  @Prop({ type: String, default: () => '' })
  title!: string;

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  @Prop({ type: Array, required: false })
  options!: IUser[];

  updateUser(val: IUser | IUser[]) {
    const user = val || [];
    this.$emit('update', Array.isArray(user) ? user : [user]);
  }

  labelUser(user: IUser) {
    return `${user.lastname}, ${user.firstname}`;
  }

  get isDefault() {
    return this.selected.length === 0;
  }

  reset() {
    this.$emit('update', []);
  }
}
